import { render, staticRenderFns } from "./SpinnerWheelTimeConfig.vue?vue&type=template&id=65c116dc&scoped=true"
import script from "./SpinnerWheelTimeConfig.vue?vue&type=script&lang=js"
export * from "./SpinnerWheelTimeConfig.vue?vue&type=script&lang=js"
import style0 from "./SpinnerWheelTimeConfig.vue?vue&type=style&index=0&id=65c116dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c116dc",
  null
  
)

export default component.exports